import axios from "axios";

const slugfy = (url) => {
  return url
    .normalize("NFD")
    .replace(RegExp("ç", "g"), "c")
    .replace(RegExp("ãáà", "g"), "a")
    .replace(RegExp("/", "g"), "")
    .replace(/\s/g, "-")
    .toLowerCase();
};

const URLtenant =
  process.env.NODE_ENV === "development"
    ? window.location.href.split("3000/", 2)[1].split("/", 1)[0]
    : window.location.href.split(".com/", 2)[1].split("/", 1)[0];

const api =
  process.env.NODE_ENV === "development"
    ? axios.create({
        baseURL: `http://api-v1.wip/api/${slugfy(URLtenant)}/`,
      })
    : axios.create({
        baseURL: `https://aws.ecorban.com/api/${slugfy(URLtenant)}/`,
      });

api.interceptors.request.use(async (config) => {
  try {
    const token = await localStorage.getItem("@ecorban-app:token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  } catch (err) {
    // TODO
  }
});

export default api;




// WEBPACK FOOTER //
// ./src/services/api.js